import { IUserDownload } from "@shared/lib/types/downloads";
import { CircularProgress } from "@shared/ui";
import { Avatar, Spin, Tag } from "antd";
import { ExternalLink } from "lucide-react";
import styles from "../../../pages/layout/DefaultLayout/ui/Header/Header.module.scss";
import { useGetIUserDownloads } from "../lib/hooks/useGetUserDownloads";

export function UserDownloadsList() {
  const { userDownloads, isFetching, isLoading } = useGetIUserDownloads();

  const getDownloadName = (item: IUserDownload) => {
    const typeLabel =
      item?.type === "vendorInvoiceTdsFilling"
        ? "Gst Invoices"
        : item?.type === "breifInfluencers"
          ? "Brief"
          : item?.type === "reportMedias"
            ? "Reports"
            : item?.type === "vendorPayments"
              ? "Payouts"
              : item?.type === "analyticsMarginDistribution"
                ? "Pricing Analytics"
                : item?.type === "brandAccounting"
                  ? ""
                  : "Bucket";
    return `Downloaded ${item?.totalRecords || 0} ${typeLabel} ${item?.type === "brandAccounting" ? "Invoices" : "Influencers"}`;
  };

  if (isLoading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <div>
      {!userDownloads || userDownloads.length === 0 ? (
        <div className={styles.emptyState}>No recent downloads</div>
      ) : (
        userDownloads.map((item: IUserDownload, index) => {
          const downloadName = getDownloadName(item);
          return (
            <div
              key={`${downloadName}-${item.createdAt}-${index}`}
              className={styles.downloadItem}
            >
              {item.createdBy && (
                <Avatar
                  src={item.createdBy.profilePicUrl}
                  size={32}
                  style={{ flexShrink: 0 }}
                >
                  {item.createdBy.firstName?.charAt(0)}
                </Avatar>
              )}
              <div className={styles.downloadContent}>
                <p className={styles.downloadName} title={downloadName}>
                  {downloadName}
                </p>
                <div className={styles.downloadMeta}>
                  {item.createdBy && (
                    <span className={styles.downloadUser}>
                      {item.createdBy.firstName} {item.createdBy.lastName}
                    </span>
                  )}
                  <Tag color={item.status === "completed" ? "green" : "red"}>
                    {item.status}
                  </Tag>
                  {item.status === "processing" && (
                    <div className={styles.processingBadge}>
                      <Spin size="small" />
                      <span>Processing</span>
                    </div>
                  )}
                </div>
              </div>
              {item.status === "completed" && item.fileUrl && (
                <a
                  href={item.fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.downloadLink}
                  title="Open in Google Sheets"
                  onClick={(e) => e.stopPropagation()}
                >
                  <ExternalLink size={16} />
                </a>
              )}
            </div>
          );
        })
      )}
    </div>
  );
}

export default UserDownloadsList;
